import { useEffect, useState } from 'react';
import { getStylization } from '../services/styles';
import { getFromSessionStorage, setInSessionStorage } from '../constants/functions';
import { AxiosError } from 'axios';

interface MenuItem {
  title: string;
  icon: string;
  route: string;
  visivel: boolean;
}

interface AcessoRapidoItem {
  id: string;
  title: string;
  quickAccessButton: string;
  visivel: boolean;
}

export interface Stylization {
  corPrimaria: string;
  corSecundaria: string;
  corTerciaria: string;
  fontePrincipal: string;
  fonteSecundaria: string;
  imagemFundo: string;
  logoPrincipal: string;
  logoSecundario: string;
  logoSidebar: string;
  subTitulo: string;
  textoRodape: string;
  textoRodapeNegrito: string;
  textoSidebar: string;
  tituloPrincipal: string;
  menuNetAtend: {
    pageList: MenuItem[];
  };
  botoesDashBoard: {
    acessoRapido: AcessoRapidoItem[];
  };
  liberarGerarNovoBoleto: string;
}

const ERROR_MESSAGE =
  'Ocorreu um erro ao tentar se conectar ao servidor. Verifique sua conexão com a internet e tente novamente.';

export const useStylization = () => {
  const [stylization, setStylization] = useState<Stylization>();

  const [error, setError] = useState<string>('');

  useEffect(() => {
    const getStyle = async () => {
      try {
        const res = (await getStylization()) as unknown as Stylization;

        if (typeof res === 'string') {
          setError(ERROR_MESSAGE);
          return;
        }

        setInSessionStorage('stylization', JSON.stringify(res));
        setStylization(res);
      } catch (e) {
        const error = e as AxiosError;

        if (error.code === 'ERR_NETWORK') {
          setError(ERROR_MESSAGE);
        }

        console.log('Erro ao buscar estilização:', e);
      }
    };

    const stored = getFromSessionStorage('stylization');
    if (stored) {
      const style = JSON.parse(stored);
      setStylization(style);
    }

    getStyle();
  }, []);

  return { stylization, error };
};
